module.exports = __webpack_public_path__ + "static/img/kee-bg.8a432261.png";